import { StateSchema } from 'app/config/storeConfig/types';
import { Warehouse } from 'entities/Warehouse';

export const getSelectedWarehouse = (state: StateSchema): Nullable<Warehouse> => state.issueInvoiceModal.selectedWarehouse;
